import { Calendar, isValidDate } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import momentPlugin from '@fullcalendar/moment'

import esFullcalendarLocale from '@fullcalendar/core/locales/es';
import valFullcalendarLocale from '../lang/val/fullcalendar';

import Masonry from 'masonry-layout';

const { default: axios } = require("axios");
const { set } = require("lodash");

let open_infowindow = null;

let home_social_feed_loading = false;
let home_social_feed_count = null;

let association_social_feed_loading = false;
let association_social_feed_count = null;

const config = {
    headers: {
        Locale: window._locale || 'es',
    }
};

document.addEventListener('DOMContentLoaded', function(){
    
    initEventsCalendar();
    initAssociationsFilter();
    initMobileMenu();
    initMasonry();
    
    initHome();
    initAssociation();

});

function initMobileMenu(){
    
    $('#mobile_header .open').click(function(){
        $('.header_wrapper').addClass('open');
    });
    
    $('.header_wrapper .close').click(function(){
        $('.header_wrapper').removeClass('open');
    });

}

window.initMaps = function(){
    initHeroMap();
    initAddressMaps();
};

function initHeroMap() {

    if($('#heromap').length > 0){
    
        const alfafar = { lat: 39.421516, lng: -0.390576 };
        window.heromap = new google.maps.Map(document.getElementById("heromap"), {
            
            zoom: 16,
            center: alfafar,
            disableDefaultUI: true,

            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles: [{
                featureType: 'poi',
                stylers: [
                    { visibility: "off" }
                ]   
            },
            {
                featureType: 'transit',
                stylers: [
                    { visibility: "off" }
                ]   
            }]

        });

        axios
            .get(window._url + '/api/associations', config)
            .then((response) => {
                if(typeof response.data.associations != 'undefined'){
                    for(let asociacion of response.data.associations){

                        if(
                            typeof asociacion.address != 'undefined'
                            && typeof asociacion.address.longitude != 'undefined'
                            && asociacion.address.longitude != ''
                            && typeof asociacion.address.latitude != 'undefined'
                            && asociacion.address.latitude != ''
                        ){

                            let marker = new google.maps.Marker({
                                position: { 
                                    lat: parseFloat(asociacion.address.latitude), 
                                    lng: parseFloat(asociacion.address.longitude), 
                                },
                                map: window.heromap,
                                title: asociacion.name,
                            });

                            if(asociacion.infowindow != ''){
                            
                                let infowindow = new google.maps.InfoWindow({
                                    content: asociacion.infowindow,
                                });

                                marker.addListener("click", () => {

                                    if(open_infowindow != null){
                                        open_infowindow.close();
                                    }

                                    infowindow.open({
                                        anchor: marker,
                                        map: window.heromap,
                                        shouldFocus: false,
                                    });

                                    open_infowindow = infowindow;

                                });

                            }

                        }

                    }
                }

            });

    }

}

function initAddressMaps(){

    $('.address_map').each(function(){

        const center = { lat: parseFloat($(this).attr('latitude')), lng: parseFloat($(this).attr('longitude')) };
        let map = new google.maps.Map($(this)[0], {
            
            zoom: 16,
            center: center,
            disableDefaultUI: true,

            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles: [{
                featureType: 'poi',
                stylers: [
                    { visibility: "off" }
                ]   
            },
            {
                featureType: 'transit',
                stylers: [
                    { visibility: "off" }
                ]   
            }]

        });

        let marker = new google.maps.Marker({
            position: center,
            map: map,
        });

    });

}

(function (global) {
    global.FullCalendar = {
        Calendar: function (elt, options) {

            // if(typeof window.moment != 'undefined'){
            //     console.log(window.moment.locale());
            // } else {
            //     console.log('moment undefined');
            // }

            return new Calendar(elt, Object.assign({

                plugins: [ dayGridPlugin, momentPlugin ],
                locales: [ esFullcalendarLocale, valFullcalendarLocale ],
                locale: window._locale,
                titleFormat: function(date){
                    return moment(date.date).format('MMMM YYYY').toUpperCase();
                },
                dayHeaderContent: function(date){
                    return moment(date.date).format('ddd');
                },
                themeSystem: 'bootstrap',
                initialView: 'dayGridMonth',
                height: 'auto',
            
                headerToolbar: {
                    left: 'title',
                    right: 'prev,next',
                },

            }, options));

        }
    }
})(window);

function initEventsCalendar(){

    var calendar = $('.calendar');
    var events = typeof calendar.attr('events') != 'undefined';
    if(calendar.length > 0){

        let association_id = calendar.attr('association_id');
        if(typeof association_id == 'undefined' || association_id == null){
            association_id = ''; 
        }

        window.home_calendar = FullCalendar.Calendar(calendar[0], {
            events: window._url + '/api/' + window._locale + '/events?association_id=' + association_id,
            editable  : false,
            droppable : false,
            eventClick: function(info){
                if(events){

                    if(info.event.extendedProps.infowindow != ''){
                        $('#event_modal .modal-content').html(info.event.extendedProps.infowindow);
                        $('#event_modal').modal('show');
                    }

                    // console.log(info.event.title);
                    // console.log(moment(info.event.start));
                    // console.log(moment(info.event.end));
                    // console.log(info.event.extendedProps);

                }
            },
            eventsSet: function(payload){

                $('.timeline-wrapper .events').html('');
                $('.timeline-wrapper .events').addClass('d-none');
                $('.timeline-wrapper .no-events').addClass('d-none');

                let events = window.home_calendar.getEvents();
                if(events.length > 0){
                    
                    for(let event of events){
                        $('.timeline-wrapper .events').append(event.extendedProps.infowindow);
                    }
                    $('.timeline-wrapper .events').removeClass('d-none');

                } else {

                    $('.timeline-wrapper .no-events').removeClass('d-none');

                }
                
            },
        });
        
        window.home_calendar.render();

    }

}

function initAssociationsFilter(){

    $('#associations input[name="filter"]').on('keyup', function(){

        let keywords = [];
        let search = $(this).val().toLowerCase();
        if(search != ''){
            for(let keyword of search.split(" ")){
                if(keyword != ""){
                    keywords.push(keyword);
                }
            }
        }
        
        if(keywords.length == 0){

            $('#associations .association').parent().show();

        } else {
            
            $('#associations .association').each(function(){
                
                let visible = true;
                let search = $(this).attr('search');

                for(let keyword of keywords){
                    if(search.indexOf(keyword) < 0){
                        visible = false;
                    }
                }

                if(visible){
                    $(this).parent().show();
                } else {
                    $(this).parent().hide();
                }

            });

        }

        doMasonry();

    });

    $('#associations input[name="filter"]').val('').trigger('keypress');

}

function initMasonry(){

    $(window).resize(doMasonry).trigger('resize');
    initMasonryImages();

}

function initMasonryImages(){

    $('.masonry img:not(.init)').one('load', function() {

        doMasonry();

    }).each(function() {

        $(this).addClass('init');

        if(this.complete){
            
            if($(this).width() > 200){
                $(this).addClass('w-100');
            }

            $(this).trigger('load'); // For jQuery >= 3.0 
            
        }
        
    });

}

function doMasonry(){
    $('.masonry').each(function(){
        let masonry = new Masonry($(this)[0], { 
            percentPosition: true,
            columnWidth: '.sizer',
        });
        masonry.reloadItems();
    });
}

function initHome(){
    if($('#home').length > 0){
        
        initHomeSocialFeed();

    }
}

function initHomeSocialFeed(){

    // infinite scroll loading
    window.addEventListener('scroll', () => {

        const {
            scrollTop,
            scrollHeight,
            clientHeight
        } = document.documentElement;

        if(scrollTop + clientHeight >= scrollHeight - 500){
            loadHomeSocialFeed();
        }

    }, {
        passive: true
    });

}

function loadHomeSocialFeed(){

    if(
        !home_social_feed_loading
        && (
            home_social_feed_count == null
            || home_social_feed_count > $('#home .social_feed .social').length
        )
    ){
        
        home_social_feed_loading = true;
        $('#home .social_feeds_loading').removeClass('d-none').show();

        // fetch events

        let route = window._routes['home.social_feed'].replace('{locale}', window._locale);
        let formData = new FormData();
        formData.append('skip', $('#home .social_feed .social').length);
        
        window.ajax.post(route, formData, false, true)
            .then((response) => {

                $('#home .social_feeds_loading').hide();

                $('#home .social_feed').append(response.data.social_feeds);
                initMasonryImages();

                home_social_feed_loading = false;
                home_social_feed_count = response.data.social_feeds_count;

            })
            .catch((error) => {

                console.log('Error loading home social feed', error);

                $('#home .social_feeds_loading').hide();
                home_social_feed_loading = false;

            });

    }

}

function initAssociation(){
    if($('#association').length > 0){

        initAssociationSocialFeed();

    }
}

function initAssociationSocialFeed(){

    // infinite scroll loading
    window.addEventListener('scroll', () => {

        const {
            scrollTop,
            scrollHeight,
            clientHeight
        } = document.documentElement;

        if(scrollTop + clientHeight >= scrollHeight - 500){
            loadAssociationSocialFeed();
        }

    }, {
        passive: true
    });

}

function loadAssociationSocialFeed(){

    if(
        !association_social_feed_loading
        && (
            association_social_feed_count == null
            || association_social_feed_count > $('#association .social_feed .social').length
        )
    ){
        
        association_social_feed_loading = true;
        $('#association .social_feeds_loading').removeClass('d-none').show();

        // fetch events

        let slug = $('#association').attr('slug');
        let route = window._routes['associations.social_feed'].replace('{locale}', window._locale).replace('{slug}', slug);
        let formData = new FormData();
        formData.append('skip', $('#association .social_feed .social').length);
        
        window.ajax.post(route, formData, false, true)
            .then((response) => {

                $('#association .social_feeds_loading').hide();

                $('#association .social_feed').append(response.data.social_feeds);
                initMasonryImages();

                association_social_feed_loading = false;
                assocition_social_feed_count = response.data.social_feeds_count;

            })
            .catch((error) => {

                console.log('Error loading association social feed', error);

                $('#association .social_feeds_loading').hide();
                association_social_feed_loading = false;

            });

    }

}